var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cancer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cancer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,8 C15.791,8 14,9.791 14,12 C14,14.209 15.791,16 18,16 C20.209,16 22,14.209 22,12 C22,9.791 20.209,8 18,8 M18,10 C19.103,10 20,10.897 20,12 C20,13.103 19.103,14 18,14 C16.897,14 16,13.103 16,12 C16,10.897 16.897,10 18,10",
    id: "Head",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,8 C3.791,8 2,9.791 2,12 C2,14.209 3.791,16 6,16 C8.209,16 10,14.209 10,12 C10,9.791 8.209,8 6,8 M6,10 C7.103,10 8,10.897 8,12 C8,13.103 7.103,14 6,14 C4.897,14 4,13.103 4,12 C4,10.897 4.897,10 6,10",
    id: "Head",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,4 C14.206,4 16.206,4.897 17.654,6.346 L19.073,4.931 C17.263,3.12 14.763,2 12,2 C6.477,2 2,6.477 2,12 L4,12 C4,7.589 7.589,4 12,4",
    id: "Tail",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,20 C9.786,20 7.781,19.095 6.331,17.638 L4.912,19.052 C6.723,20.872 9.229,22 12,22 C17.523,22 22,17.523 22,12 L20,12 C20,16.411 16.411,20 12,20",
    id: "Tail",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancer);
export default __webpack_public_path__ + "static/media/cancer.0018cb87d3970712b0e51f7b3c50aa0d.svg";
export { ForwardRef as ReactComponent };